import React, { useRef } from 'react';
import { AccessibilityElement } from '@core/js/components/common/AccessibilityElement';
import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';
import { useOpenGame } from '@theme/js/components/main/TopWinners/hooks/useOpenGame';

import style from '@core/js/components/main/TopWinners/components/Line/components/LineItem/LineItem.scss';

export const LineItem = (props) => {
    const { gameCode: code, player, winAmount, gameName, showSeparator } = props;
    const winnerRef = useRef();
    const translate = useComponentTranslations();

    const openGame = useOpenGame(code, winnerRef); /* Lugano changes */

    return (
        <>
            <AccessibilityElement
                inline={true}
                onClick={openGame}
                elementRef={winnerRef}
                className={style.topWinner}
                aria-label={`${translate('playtech.mobile.system.game.aria-label')} ${gameName}`}
            >
                <span className={style.justWon}>{`${player} ${translate('justWon')} `}</span>
                <span className={style.winAmount}>{winAmount}</span>
                <span>{` ${translate('inGame')} ${gameName}`}</span>
            </AccessibilityElement>
            {showSeparator && (
                <span className={style.separator}>
                    {translate('lineView.separator')}
                </span>
            )}
        </>
    );
};
